<template>
  <div>
    <div class="date-input-container">
      <div class="date-field short">
        <v-combobox
          v-model="dd"
          :items="days"
          placeholder="Ngày (DD)"
          inputmode="numeric"
          maxlength="2"
          outlined
          dense
          hide-details
          clearable
          :menu-props="menuProps"
          @input="onDayInput"
          @change="onDayChange"
          ref="day"
        />
      </div>
      <span class="date-separator">/</span>
      <div class="date-field short">
        <v-combobox
          v-model="mm"
          :items="months"
          placeholder="Tháng (MM)"
          inputmode="numeric"
          maxlength="2"
          outlined
          dense
          hide-details
          clearable
          :menu-props="menuProps"
          @input="onMonthInput"
          @change="onMonthChange"
          ref="month"
        />
      </div>
      <span class="date-separator">/</span>
      <div class="date-field long">
        <v-combobox
          v-model="yyyy"
          :items="years"
          placeholder="Năm (YYYY)"
          inputmode="numeric"
          maxlength="4"
          outlined
          dense
          hide-details
          clearable
          :menu-props="menuProps"
          @input="emitDate"
          ref="year"
        />
      </div>
    </div>
    <VMessages v-if="errorText" class="caption error--text pl-3 error-text" :value="[errorText]" color="error" />
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['value'],
  data() {
    return {
      days: Array.from({length: 31}, (_, i) => (i + 1).toString().padStart(2, '0')),
      months: Array.from({length: 12}, (_, i) => (i + 1).toString().padStart(2, '0')),
      years: Array.from({length: 28}, (_, i) => (2000 + i).toString()),
      menuProps: {maxHeight: 200},
      dd: '',
      mm: '',
      yyyy: '',
      errorText: '',
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (!value) return

        const date = moment(value, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601], true)
        if (!date.isValid()) return

        this.dd = date.format('DD')
        this.mm = date.format('MM')
        this.yyyy = date.format('YYYY')
      },
    },
  },
  methods: {
    normalizePart(value, maxLength) {
      return value === null || value === undefined ? '' : String(value).replace(/\D/g, '').slice(0, maxLength)
    },
    onDayInput(value) {
      this.dd = this.normalizePart(value, 2)
      if (this.dd.length === 2) this.$nextTick(() => this.$refs.month.focus())
      this.emitDate()
    },
    onMonthInput(value) {
      this.mm = this.normalizePart(value, 2)
      if (this.mm.length === 2) this.$nextTick(() => this.$refs.year.focus())
      this.emitDate()
    },
    onDayChange() {
      if (this.dd) this.$refs.month.focus()
      this.emitDate()
    },
    onMonthChange() {
      if (this.mm) this.$refs.year.focus()
      this.emitDate()
    },
    emitDate(value) {
      if (value !== undefined) this.yyyy = this.normalizePart(value, 4)

      const {isValid, fullDate} = this.validate()
      this.errorText = isValid || !this.dd || !this.mm || !this.yyyy ? '' : 'Vui lòng kiểm tra lại ngày sinh'
      this.$emit('input', fullDate)
    },
    validate() {
      const fullDate = `${this.dd || ''}/${this.mm || ''}/${this.yyyy || ''}`
      const isValid = moment(fullDate, 'DD/MM/YYYY', true).isValid() && Number(this.yyyy) <= 2027
      return {isValid, fullDate}
    },
  },
}
</script>

<style scoped>
.date-input-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.date-separator {
  font-size: 1.2rem;
  font-weight: bold;
  color: #757575;
}

.date-field.short {
  width: 145px;
}

.date-field.long {
  width: 170px;
}

::v-deep .v-text-field input {
  text-align: center;
}
</style>
